



import { Prop, Component, Vue } from "vue-property-decorator";
@Component({name:"default-navigator"})
export default class DefaultNavigatorComponent extends Vue {}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/default/default-navigator.vue